import Vue from 'vue'
import Vuex from 'vuex'
import firebase from "firebase/app";

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: null,
    nickname: "",
    avatarurl: "",
    assessmentidparam: null,
    userhasfilledhisassessment: null,
    iamtheboss: null,
  },
  getters: {
    getUser: (state) => {
      //console.log('store.js getter getUser fired state is ')
      //console.log(state.user)
      // if (localStorage.getItem('exdevLSuser') !== null) {
      //   state.user = localStorage.getItem('exdevLSuser')
      // }
      return state.user;
    },
    getAssessmentIdParam: (state) => {
      if (localStorage.getItem('exdevLSnewassessmentidparam') !== null) {
        state.assessmentidparam = localStorage.getItem('exdevLSnewassessmentidparam')
      }
      return state.assessmentidparam;
    },
    getUserhasfilledhisassessment: (state) => {
      if (localStorage.getItem('exdevLSuserhasfilledhisassessment') !== null) {
        state.userhasfilledhisassessment = localStorage.getItem('exdevLSuserhasfilledhisassessment')
      }
      return state.userhasfilledhisassessment;
    },
    getIamtheboss: (state) => {

      if (localStorage.getItem('exdevLSiamtheboss') !== null) {
        state.iamtheboss = localStorage.getItem('exdevLSiamtheboss')
      }
      //console.log('getter getIamtheboss called and returned ' + state.iamtheboss)
      return state.iamtheboss;
    },
    getNickname: (state) => {
      if (localStorage.getItem('exdevLSnickname') !== null) {
        state.nickname = localStorage.getItem('exdevLSnickname')
      }
      return state.nickname;
    },
    getAvatarurl: (state) => {

      if (localStorage.getItem('exdevLSavatarurl') !== null) {
        state.avatarurl = localStorage.getItem('exdevLSavatarurl')
      }
      //console.log('48 getAvatarurl returning: ' + state.avatarurl)

      return state.avatarurl;
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      localStorage.setItem('exdevLSuser', state.user);

    },
    setAssessmentIdParam(state, newassessmentidparam) {
      state.assessmentidparam = newassessmentidparam;
      localStorage.setItem('exdevLSnewassessmentidparam', state.assessmentidparam);
    },
    setUserhasfilledhisassessment(state, newuserhasfilledhisassessment) {
      state.userhasfilledhisassessment = newuserhasfilledhisassessment;
      localStorage.setItem('exdevLSuserhasfilledhisassessment', state.userhasfilledhisassessment);
    },
    setIamtheboss(state, iamtheboss) {
      console.log('mutation setIamtheboss called with arg iamtheboss=' + iamtheboss);
      state.iamtheboss = iamtheboss;
      localStorage.setItem('exdevLSiamtheboss', iamtheboss);
    },
    setNickname(state, nickname) {

      state.nickname = nickname;
      localStorage.setItem('exdevLSnickname', nickname);
    },
    setAvatarurl(state, avatarurl) {
      state.avatarurl = avatarurl;
      console.log('mutation 81 setAvatarurl setting ' + avatarurl)

      localStorage.setItem('exdevLSavatarurl', avatarurl);
    },

  },
  actions: {
    setUser(context, user) {
      context.commit('setUser', user);
    },
    setAssessmentIdParam(context, assessmentidparam) {
      context.commit('setAssessmentIdParam', assessmentidparam)
      console.log('action setAssessmentIdParam called with arg assessmentidparam=' + assessmentidparam);
    },
    setUserhasfilledhisassessment(context, userhasfilledhisassessment) {
      context.commit('setUserhasfilledhisassessment', userhasfilledhisassessment)
      //console.log('action setAssessmentIdParam called with arg assessmentidparam='+assessmentidparam);
    },
    setIamtheboss(context, iamtheboss) {
      context.commit('setIamtheboss', iamtheboss)
      console.log('action setIamtheboss called with arg iamtheboss=' + iamtheboss);
    },
    setNickname(context, nickname) {
      console.log('committing nickname ' + nickname)

      context.commit('setNickname', nickname)
    },
    setAvatarurl(context, avatarurl) {
      console.log('committing avatarurl ' + avatarurl)

      context.commit('setAvatarurl', avatarurl)
    },
  }
})
